import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';
import Process from './Process';

const { name } = STORE.modules.recipes;

export default class Recipes extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      unique_id: this.string(''),
      process_id: this.number(null),
      process: this.belongsTo(Process, 'process_id'),
      name: this.string(''),
      ingredients: this.attr([]),
      ferments: this.attr([]),
      parameters: this.attr([]),
      product_needed: this.number(0),
      losses: this.number(0),
      batch: this.number(0),
      graph: this.attr(''),
    };
  }
}
